<template>
<div style="">
     <div class="zhichi-header">
         <div style="width:1240px;margin:0 auto">
              <div class="header-left" ></div>
         </div>
       
        <div class="header-title">
            <span>红杉会议下载中心</span>
        </div>
        <div class="header-ul">
            <ul>
                <li v-for="(item,index) in tabs1" :key="index" @click="gets(index)" :class="{'dactive':index ==current}"><router-link :to="item.path">{{item.name}}</router-link></li>
            </ul>
        </div>
        <div style="margin-bottom:320px">
            <router-view></router-view>
        </div>
    </div>
</div>
   
</template>
<script>
export default {
    data(){
        return{
            tabs1:[
                {
                    name:'红杉会议客户端',
                    path:'/huduan'
                },
				{
                    name:'SDK',
                    path:'/sdk'
                },
                 {
                    name:'Rooms',
                    path:'/rooms'
                },
                 {
                    name:'服务器',
                    path:'/service'
                }
            ],
            current:0,
            setHeight:''
        }
    },
     created(){
          // 获取分辨率
          this.setHeight =  window.screen.width;
        },
    methods:{
        gets(index){
            this.current = index
        }
    }
}
</script>
<style lang="scss">
   html,body{  overflow-x:hidden;}
     .dactive{
         background-color: #fff !important;
         border-radius: 10px;
         box-shadow: 0 0 5px 3px rgba(14, 113, 235, 0.15);
     }
    .zhichi-header{
        width: 100%;
        background: linear-gradient(to bottom,#95cdff, #fff);
        .header-left{
            position: absolute;
            height: 525px;
            top: 60px;
            width: 100%;
            background: url('../../assets/image/beij1.png') no-repeat;
        }
        .header-title{
           text-align: center;
           position: relative;
           top:220px;
           span{
                font-size: 32px;
                color: #323232;
           }
        }
        .header-ul{
            position: relative;
            top:260px;
            display: flex;
            justify-content: center;
            ul{
                  display: flex;
                  justify-content: space-between;
                  background-color:#EFFAFF;
                  width: 571px;
                  height: 54px;
                  border-radius: 10px;
                  line-height: 54px;
                  li{
                     background-color:#EFFAFF;
                     width: 181px;
                     height: 53px;
                     border-radius: 10px;
                     font-size: 18px;
                     text-align: center;
                     a{   display: block;
                          color: #5B5B5B;
                          cursor: pointer;
                     }
                  }
            }
        }
    }
    .keku-header .header-tabs .tabs {
            width: 386px;
            height: 227px;
            background: #FFFFFF;
            border: 1px solid #F1F1F1;
            border-radius: 10px;
            text-align: center;
            cursor: pointer;
            margin-top: 40px;
        }
</style>